import { DecimalPipe, NgIf } from '@angular/common';
import { maskitoTransform } from '@maskito/core';
import { Component, OnInit } from '@angular/core';
import { mask_porcentagem_limpa } from '../../directives/mascaras';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { AcessoOfertaEducacionalStateService, EtapasDeEdicaoService } from '../../services';
import { LayoutEditorContentService, IconeAtivo } from '../../layouts/layout-editor/layout-editor-content.service';
import {
  caminhoImagemLateral,
  corFundoLateral,
  opcoesMenusLateralAtivas,
  tituloMenuLateral,
} from '../../layouts/layout-editor/template/lateral-navegacao-acesso-oferta-educacional';
import { EtapasEnsino } from '../../enums/etapas-ensino.enum';
import { CarregamentoService } from '../../services/carregamento/carregamento.service';
import { AnosReferenciasService } from '../../services/anos-referencias/anos-referencias.service';
import { AnosReferenciasDto } from '../../dtos/anos-referencias.dto';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-resultado-projecao',
  standalone: true,
  imports: [
    TabelaComponent,
    DecimalPipe,
    NgIf
  ],
  templateUrl: './resultado-projecao.component.html',
  styleUrl: './resultado-projecao.component.scss'
})
export class ResultadoProjecaoComponent implements OnInit {
  anosReferencias: AnosReferenciasDto | null = null;
  anoCenso: number;
  exibirCrechePorIdade = false;

  totalMatriculasCreche = 0;
  totalMatriculasDiurnoCreche = 0;
  totalMatriculasIntegralCreche = 0;
  totalMatriculasNoturnoCreche = 0;
  porcentagemIntegralCreche = '';

  totalMatriculasCrecheMenor1Ano = 0;
  totalMatriculasDiurnoCrecheMenor1Ano = 0;
  totalMatriculasIntegralCrecheMenor1Ano = 0;
  totalMatriculasNoturnoCrecheMenor1Ano = 0;
  porcentagemIntegralCrecheMenor1Ano = '';

  totalMatriculasCreche1Ano = 0;
  totalMatriculasDiurnoCreche1Ano = 0;
  totalMatriculasIntegralCreche1Ano = 0;
  totalMatriculasNoturnoCreche1Ano = 0;
  porcentagemIntegralCreche1Ano = '';

  totalMatriculasCreche2Anos = 0;
  totalMatriculasDiurnoCreche2Anos = 0;
  totalMatriculasIntegralCreche2Anos = 0;
  totalMatriculasNoturnoCreche2Anos = 0;
  porcentagemIntegralCreche2Anos = '';

  totalMatriculasCreche3Anos = 0;
  totalMatriculasDiurnoCreche3Anos = 0;
  totalMatriculasIntegralCreche3Anos = 0;
  totalMatriculasNoturnoCreche3Anos = 0;
  porcentagemIntegralCreche3Anos = '';

  totalMatriculasPreEscola = 0;
  totalMatriculasDiurnoPreEscola = 0;
  totalMatriculasIntegralPreEscola = 0;
  totalMatriculasNoturnoPreEscola = 0;
  porcentagemIntegralPreEscola = '';

  totalMatriculasEnsinoFundamentalAnosIniciais = 0;
  totalMatriculasDiurnoEnsinoFundamentalAnosIniciais = 0;
  totalMatriculasIntegralEnsinoFundamentalAnosIniciais = 0;
  totalMatriculasNoturnoEnsinoFundamentalAnosIniciais = 0;
  porcentagemIntegralEnsinoFundamentalAnosIniciais = '';

  totalMatriculasEnsinoFundamentalAnosFinais = 0;
  totalMatriculasDiurnoEnsinoFundamentalAnosFinais = 0;
  totalMatriculasIntegralEnsinoFundamentalAnosFinais = 0;
  totalMatriculasNoturnoEnsinoFundamentalAnosFinais = 0;
  porcentagemIntegralEnsinoFundamentalAnosFinais = '';

  totalMatriculasEnsinoMedio = 0;
  totalMatriculasDiurnoEnsinoMedio = 0;
  totalMatriculasIntegralEnsinoMedio = 0;
  totalMatriculasNoturnoEnsinoMedio = 0;
  porcentagemIntegralEnsinoMedio = '';

  totalMatriculasEja = 0;
  totalMatriculasDiurnoEja = 0;
  totalMatriculasIntegralEja = 0;
  totalMatriculasNoturnoEja = 0;
  porcentagemIntegralEja = '';

  totalGeralMatriculas = 0;
  totalGeralDiurno = 0;
  totalGeralIntegral = 0;
  totalGeralNoturno = 0;
  porcentagemIntegralGeral = '';

  constructor(
    private etapasDeEdicaoService: EtapasDeEdicaoService,
    private layoutEditorContentService: LayoutEditorContentService,
    private acessoOfertaEducacionalStateService: AcessoOfertaEducacionalStateService,
    private carregamentoService: CarregamentoService,
    private anosReferenciasService: AnosReferenciasService,
    private featureFlagService: FeatureFlagService
  ) {
    if (this.featureFlagService.funcionalidadeHabilitada('940-atualizacao-de-componentes-de-edicao-pqr')) {
      this.anosReferencias = this.anosReferenciasService.obterAnosReferenciasSnapshot();
    }
    this.anoCenso = this.anosReferencias?.anoCenso ?? 2025;
    this.exibirCrechePorIdade = this.featureFlagService.funcionalidadeHabilitada('1104-creche-idade');
  }

  ngOnInit(): void {
    this.etapasDeEdicaoService.setOpcaoAtual(3);

    this.layoutEditorContentService.definirIconeAtivo(IconeAtivo.ANDARILHO);
    this.layoutEditorContentService.definirTituloMenuLateral(tituloMenuLateral);
    this.layoutEditorContentService.definirCorFundoMenuLateral(corFundoLateral);
    this.layoutEditorContentService.definirOpcoesAtivas(opcoesMenusLateralAtivas);
    this.layoutEditorContentService.definirCaminhoImagem(caminhoImagemLateral);
    this.layoutEditorContentService.definirOpcoesInativas([]);
    this.layoutEditorContentService.definiOpcaoAtivaSelecionada(2);
    this.layoutEditorContentService.definirExibirBotaoAnterior(true);
    this.layoutEditorContentService.definirRotaAnterior('/relatorio2/acesso-oferta-educacional/projecao-da-oferta');
    this.layoutEditorContentService.definirExibirBotaoProximo(true);
    this.layoutEditorContentService.definirRotaProximo('/relatorio2/condicao-qualidade/numero-de-dias-letivos');

    if (this.acessoOfertaEducacionalStateService.carregando.getValue()) {
      this.acessoOfertaEducacionalStateService.carregando.subscribe(() => {
        this.calcularTotais();
      });
    }

    this.calcularTotais();
  }

  private calcularTotais(): void {
    this.calcularTotalMatriculasCreche();

    if (this.exibirCrechePorIdade) {
      this.calcularTotalMatriculasCrecheMenor1Ano();
      this.calcularTotalMatriculasCreche1Ano();
      this.calcularTotalMatriculasCreche2Anos();
      this.calcularTotalMatriculasCreche3Anos();
    }

    this.calcularTotalMatriculasPreEscola();

    this.calcularTotalMatriculasEnsinoFundamentalAnosIniciais();

    this.calcularTotalMatriculasEnsinoFundamentalAnosFinais();

    this.calcularTotalMatriculasEnsinoMedio();

    this.calcularTotalMatriculasEja();

    this.calcularTotalGeral();
  }

  calcularTotalMatriculasCreche(): void {
    const resultado = this.somarPorEtapa(EtapasEnsino.CRECHE);
    this.totalMatriculasCreche = resultado.totalGeral;
    this.totalMatriculasDiurnoCreche = resultado.diurnoTotal;
    this.totalMatriculasIntegralCreche = resultado.integral;
    this.totalMatriculasNoturnoCreche = resultado.noturno;
    this.porcentagemIntegralCreche = this.formatarPorcentagem(resultado.integral, resultado.totalGeral);
  }

  calcularTotalMatriculasCrecheMenor1Ano(): void {
    const resultado = this.somarPorEtapa(EtapasEnsino.CRECHE_MENOR_1_ANO);
    this.totalMatriculasCrecheMenor1Ano = resultado.totalGeral;
    this.totalMatriculasDiurnoCrecheMenor1Ano = resultado.diurnoTotal;
    this.totalMatriculasIntegralCrecheMenor1Ano = resultado.integral;
    this.totalMatriculasNoturnoCrecheMenor1Ano = resultado.noturno;
    this.porcentagemIntegralCrecheMenor1Ano = this.formatarPorcentagem(resultado.integral, resultado.totalGeral);
  }

  calcularTotalMatriculasCreche1Ano(): void {
    const resultado = this.somarPorEtapa(EtapasEnsino.CRECHE_1_ANO);
    this.totalMatriculasCreche1Ano = resultado.totalGeral;
    this.totalMatriculasDiurnoCreche1Ano = resultado.diurnoTotal;
    this.totalMatriculasIntegralCreche1Ano = resultado.integral;
    this.totalMatriculasNoturnoCreche1Ano = resultado.noturno;
    this.porcentagemIntegralCreche1Ano = this.formatarPorcentagem(resultado.integral, resultado.totalGeral);
  }

  calcularTotalMatriculasCreche2Anos(): void {
    const resultado = this.somarPorEtapa(EtapasEnsino.CRECHE_2_ANOS);
    this.totalMatriculasCreche2Anos = resultado.totalGeral;
    this.totalMatriculasDiurnoCreche2Anos = resultado.diurnoTotal;
    this.totalMatriculasIntegralCreche2Anos = resultado.integral;
    this.totalMatriculasNoturnoCreche2Anos = resultado.noturno;
    this.porcentagemIntegralCreche2Anos = this.formatarPorcentagem(resultado.integral, resultado.totalGeral);
  }

  calcularTotalMatriculasCreche3Anos(): void {
    const resultado = this.somarPorEtapa(EtapasEnsino.CRECHE_3_ANOS);
    this.totalMatriculasCreche3Anos = resultado.totalGeral;
    this.totalMatriculasDiurnoCreche3Anos = resultado.diurnoTotal;
    this.totalMatriculasIntegralCreche3Anos = resultado.integral;
    this.totalMatriculasNoturnoCreche3Anos = resultado.noturno;
    this.porcentagemIntegralCreche3Anos = this.formatarPorcentagem(resultado.integral, resultado.totalGeral);
  }

  calcularTotalMatriculasPreEscola(): void {
    const resultado = this.somarPorEtapa(EtapasEnsino.PRE_ESCOLA);
    this.totalMatriculasPreEscola = resultado.totalGeral;
    this.totalMatriculasDiurnoPreEscola = resultado.diurnoTotal;
    this.totalMatriculasIntegralPreEscola = resultado.integral;
    this.totalMatriculasNoturnoPreEscola = resultado.noturno;
    this.porcentagemIntegralPreEscola = this.formatarPorcentagem(resultado.integral, resultado.totalGeral);
  }

  calcularTotalMatriculasEnsinoFundamentalAnosIniciais(): void {
    const resultado = this.somarPorEtapa(EtapasEnsino.FUNDAMENTAL_INICIAIS);
    this.totalMatriculasEnsinoFundamentalAnosIniciais = resultado.totalGeral;
    this.totalMatriculasDiurnoEnsinoFundamentalAnosIniciais = resultado.diurnoTotal;
    this.totalMatriculasIntegralEnsinoFundamentalAnosIniciais = resultado.integral;
    this.totalMatriculasNoturnoEnsinoFundamentalAnosIniciais = resultado.noturno;
    this.porcentagemIntegralEnsinoFundamentalAnosIniciais = this.formatarPorcentagem(resultado.integral, resultado.totalGeral);
  }

  calcularTotalMatriculasEnsinoFundamentalAnosFinais(): void {
    const resultado = this.somarPorEtapa(EtapasEnsino.FUNDAMENTAL_FINAIS);
    this.totalMatriculasEnsinoFundamentalAnosFinais = resultado.totalGeral;
    this.totalMatriculasDiurnoEnsinoFundamentalAnosFinais = resultado.diurnoTotal;
    this.totalMatriculasIntegralEnsinoFundamentalAnosFinais = resultado.integral;
    this.totalMatriculasNoturnoEnsinoFundamentalAnosFinais = resultado.noturno;
    this.porcentagemIntegralEnsinoFundamentalAnosFinais = this.formatarPorcentagem(resultado.integral, resultado.totalGeral);
  }

  calcularTotalMatriculasEnsinoMedio(): void {
    const resultado = this.somarPorEtapa(EtapasEnsino.MEDIO);
    this.totalMatriculasEnsinoMedio = resultado.totalGeral;
    this.totalMatriculasDiurnoEnsinoMedio = resultado.diurnoTotal;
    this.totalMatriculasIntegralEnsinoMedio = resultado.integral;
    this.totalMatriculasNoturnoEnsinoMedio = resultado.noturno;
    this.porcentagemIntegralEnsinoMedio = this.formatarPorcentagem(resultado.integral, resultado.totalGeral);
  }

  calcularTotalMatriculasEja(): void {
    const resultado = this.somarPorEtapa(EtapasEnsino.EJA);
    this.totalMatriculasEja = resultado.totalGeral;
    this.totalMatriculasDiurnoEja = resultado.diurnoTotal;
    this.totalMatriculasIntegralEja = resultado.integral;
    this.totalMatriculasNoturnoEja = resultado.noturno;
    this.porcentagemIntegralEja = this.formatarPorcentagem(resultado.integral, resultado.totalGeral);
  }

  private calcularTotalGeral(): void {
    this.totalGeralMatriculas = this.totalMatriculasCreche + this.totalMatriculasPreEscola
      + this.totalMatriculasEnsinoFundamentalAnosIniciais + this.totalMatriculasEnsinoFundamentalAnosFinais
      + this.totalMatriculasEnsinoMedio + this.totalMatriculasEja;
    this.totalGeralDiurno = this.totalMatriculasDiurnoCreche + this.totalMatriculasDiurnoPreEscola
      + this.totalMatriculasDiurnoEnsinoFundamentalAnosIniciais + this.totalMatriculasDiurnoEnsinoFundamentalAnosFinais
      + this.totalMatriculasDiurnoEnsinoMedio + this.totalMatriculasDiurnoEja;
    this.totalGeralIntegral = this.totalMatriculasIntegralCreche + this.totalMatriculasIntegralPreEscola
      + this.totalMatriculasIntegralEnsinoFundamentalAnosIniciais + this.totalMatriculasIntegralEnsinoFundamentalAnosFinais
      + this.totalMatriculasIntegralEnsinoMedio + this.totalMatriculasIntegralEja;
    this.totalGeralNoturno = this.totalMatriculasNoturnoCreche + this.totalMatriculasNoturnoPreEscola
      + this.totalMatriculasNoturnoEnsinoFundamentalAnosIniciais + this.totalMatriculasNoturnoEnsinoFundamentalAnosFinais
      + this.totalMatriculasNoturnoEnsinoMedio + this.totalMatriculasNoturnoEja;
    this.porcentagemIntegralGeral = this.formatarPorcentagem(this.totalGeralIntegral, this.totalGeralMatriculas);
  }


  private somarPorEtapa(cod: EtapasEnsino): {
    integral: number; diurnoTotal: number; noturno: number; totalGeral: number;
  } {
    let parcial = 0, integral = 0, noturno = 0;
    for (const proj of this.acessoOfertaEducacionalStateService.getProjecoesOfertaMatriculas()) {
      const etapa = proj.etapasEnsino.find(x => x.codEtapaEnsino === cod);
      if (!etapa) continue;

      parcial += etapa.numeroMatriculasDiurno ?? 0;
      integral += etapa.numeroMatriculasIntegral ?? 0;
      noturno += etapa.numeroMatriculasNoturno ?? 0;
    }
    const diurnoTotal = parcial + integral;
    const totalGeral = diurnoTotal + noturno;

    return { integral, diurnoTotal, noturno, totalGeral };
  }

  private formatarPorcentagem(integral: number, total: number): string {
    const valor = total > 0 ? Math.round((integral / total) * 100 * 10) / 10 : 0;
    return maskitoTransform(String(valor), mask_porcentagem_limpa) ?? '';
  }

}
